var _a;
export var actionTypePrefix = '@@ReportPageModal';
export var reduxKey = '@@ReportPageModal';
export var ReportSectionTypes;
(function (ReportSectionTypes) {
    ReportSectionTypes["Home"] = "home";
    ReportSectionTypes["Inappropriate"] = "inappropriate";
    ReportSectionTypes["SpamMalwareWarez"] = "spam-malware-warez";
    ReportSectionTypes["IpViolation"] = "ip-violation";
    ReportSectionTypes["ThirdPartyIp"] = "third-party-ip";
    ReportSectionTypes["FirstPartyIp"] = "first-party-ip";
    ReportSectionTypes["SomethingElse"] = "something-else";
    ReportSectionTypes["Mature"] = "mature";
    ReportSectionTypes["Underage"] = "underage";
    ReportSectionTypes["Explicit"] = "explicit";
    ReportSectionTypes["Block"] = "block";
    ReportSectionTypes["Misplaced"] = "misplaced";
    ReportSectionTypes["Abuse"] = "abuse";
    ReportSectionTypes["SelfHarm"] = "self-harm";
    ReportSectionTypes["Spam"] = "spam";
    ReportSectionTypes["Malware"] = "malware";
    ReportSectionTypes["Warez"] = "warez";
})(ReportSectionTypes || (ReportSectionTypes = {}));
export var ReportSectionForms = (_a = {},
    _a[ReportSectionTypes.ThirdPartyIp] = 30,
    _a[ReportSectionTypes.FirstPartyIp] = 39,
    _a[ReportSectionTypes.Mature] = 4,
    _a[ReportSectionTypes.Underage] = 28,
    _a[ReportSectionTypes.Explicit] = 37,
    _a[ReportSectionTypes.Misplaced] = 2,
    _a[ReportSectionTypes.Abuse] = 3,
    _a[ReportSectionTypes.SelfHarm] = 45,
    _a[ReportSectionTypes.Spam] = 44,
    _a[ReportSectionTypes.Malware] = 32,
    _a[ReportSectionTypes.Warez] = 33,
    _a);
//# sourceMappingURL=constants.js.map